module.exports = __webpack_public_path__ + "img/BlendBuff-NextLuck.42832f4f.png";